import axios from "axios";

const envBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").trim();
const BACKEND_URL = envBackendUrl.replace(/\/+$/, "");
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach fallback Bearer token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pos_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Attach selected outlet_id to GET requests automatically (unless explicitly set)
  const method = (config.method || "get").toLowerCase();
  if (method === "get") {
    const oid = localStorage.getItem("pos_outlet") || "";
    if (oid && (!config.params || !("outlet_id" in config.params))) {
      config.params = { ...(config.params || {}), outlet_id: oid };
    }
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(Number(n || 0));

export default api;
